// *******************************************************
// Interface - Counter
// -------------------------------------------------------

// *******************************************
// Module Imports
// -------------------------------------------
import React, { Component, Fragment } from 'react';
// --------------------------------

// *******************************************
// Constant Imports
// -------------------------------------------
import { Routes } from '../../../constants';
// --------------------------------

// *******************************************
// Style Imports
// -------------------------------------------
import { Fill, Text, Components } from '../../../styles';
// --------------------------------

class Links extends Component {

    onClick = () => {
        const { onClick, link } = this.props;
        onClick(link);
    }

    _getPositionByButtonType = () => {
        const { link } = this.props;

        switch (link) {
            case Routes.Kitchen:
                return {xPos: 1920, yPos: 40};
            case Routes.Garden:
                return {xPos: 1800, yPos: 40};
            case Routes.Market:
                return {xPos: 1680, yPos: 40};
            default:
                return {xPos: 1920, yPos: 40};
        }
    }

    _renderKitchenIcon = () => {
        return (
            <Fragment>
                <g style={{pointerEvents: "none"}}>
                    <path class={[Fill.white].join(" ")} d="M55.72,56.49v3.85c-3.5,2.14-7.15,2.8-11.56,2.8s-8.05-.66-11.56-2.8V56.49S36.76,59.56,44,59.64,55.72,56.49,55.72,56.49Z"/>
                    <path class={[Fill.white].join(" ")} d="M67.28,37.48c0-.07,0-.14,0-.21A10.1,10.1,0,0,0,57.19,28h0a9.5,9.5,0,0,0-1.35.09A14.44,14.44,0,0,0,30.91,31l-.11,0-.37,0h-.17l-.47,0h-.07c-.23,0-.47,0-.7,0h0a8.67,8.67,0,0,0,.13,17.28h.06l.55,0h.51l.25,0,.22,0,.3,0,.13,0a7.07,7.07,0,0,0,.82-.17,15.93,15.93,0,0,1,.68,4.62V54a21.49,21.49,0,0,0,23.11,0V52.54a16,16,0,0,1,.61-4.37l.42,0h.43l.7,0,.22,0,.62-.08.32-.05.35-.08c.21,0,.41-.1.61-.16l.2-.06A10.12,10.12,0,0,0,66.9,40.9c0-.06,0-.12,0-.18a10,10,0,0,0,.35-2.62c0-.14,0-.29,0-.43S67.28,37.54,67.28,37.48ZM38.57,51.16c0,.66-.33,1.2-.72,1.2s-.72-.54-.72-1.2V42.62c0-.67.32-1.2.72-1.2s.72.54.72,1.2Zm6.86,1.57a1.26,1.26,0,1,1-2.52,0V39.12a1.26,1.26,0,1,1,2.52,0Zm5.78-1.57c0,.66-.32,1.2-.72,1.2s-.73-.54-.73-1.2V42.62c0-.67.33-1.2.73-1.2s.72.54.72,1.2Z"/>
                </g>
            </Fragment>
        );
    }

    _renderGardenIcon = () => {
        return (
            <Fragment>
                <path class={[Fill.white].join(" ")} d="M42.49,18.72a22.41,22.41,0,0,0-2.77,1.49,45.42,45.42,0,0,1,5.5,19.18A59.49,59.49,0,0,0,42.49,18.72Z"/>
                <path class={[Fill.white].join(" ")} d="M50.39,22.89A34.74,34.74,0,0,0,44.28,39.4c-.46-5.78.23-13.27,3.07-18.37Z"/>
                <path class={[Fill.white].join(" ")} d="M41.81,24.89a28.12,28.12,0,0,1,3.26,13.05c-.86-3.7-3.07-9-5.66-11Z"/>
                <path class={[Fill.white].join(" ")} d="M44.9,34.18c4.27,0,4.23,5.58,4.23,14.4S47.24,69.49,44.9,69.49,40.67,57.4,40.67,48.58,40.63,34.18,44.9,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M44.9,34.18c4.27,0,4.23,5.58,4.23,14.4S47.24,69.49,44.9,69.49,40.67,57.4,40.67,48.58,40.63,34.18,44.9,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M45.31,44.16c0,7.35-1.57,17.4-3.51,17.55.77,4.44,1.87,7.78,3.1,7.78,2.34,0,4.23-12.09,4.23-20.91s0-14.4-4.23-14.4c-.12,0-.23,0-.34,0C45.32,36.27,45.31,39.72,45.31,44.16Z"/>
                <ellipse class={[Fill.white].join(" ")} cx="43.1" cy="59.7" rx="1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="45.1" cy="45.2" rx="2.1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="45.5" cy="54.4" rx="1.7" ry=".3"/>
                <path class={[Fill.white].join(" ")} d="M49.09 43.36c0-.23 0-.46 0-.68-.92 0-1.66.16-1.66.34S48.16 43.35 49.09 43.36zM43.42 47.82c0-.25-1-.45-2.23-.45h-.51c0 .29 0 .57 0 .87h.51C42.42 48.27 43.42 48.07 43.42 47.82zM44.67 64.24c0 .2.82.37 1.83.37a7.69 7.69 0 0 0 .91-.06c0-.2.1-.39.14-.6a7.33 7.33 0 0 0-1.06-.07C45.49 63.88 44.67 64 44.67 64.24zM56.44 18.72a22.41 22.41 0 0 0-2.77 1.49 45.42 45.42 0 0 1 5.5 19.18A59.49 59.49 0 0 0 56.44 18.72z"/>
                <path class={[Fill.white].join(" ")} d="M64.35,22.89A34.74,34.74,0,0,0,58.23,39.4c-.46-5.78.23-13.27,3.07-18.37Z"/>
                <path class={[Fill.white].join(" ")} d="M55.77,24.89A28.12,28.12,0,0,1,59,37.95c-.86-3.7-3.07-9-5.66-11Z"/>
                <path class={[Fill.white].join(" ")} d="M58.86,34.18c4.27,0,4.23,5.58,4.23,14.4s-1.89,20.91-4.23,20.91S54.63,57.4,54.63,48.58,54.58,34.18,58.86,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M58.86,34.18c4.27,0,4.23,5.58,4.23,14.4s-1.89,20.91-4.23,20.91S54.63,57.4,54.63,48.58,54.58,34.18,58.86,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M59.27,44.16c0,7.35-1.57,17.4-3.51,17.55.77,4.44,1.87,7.78,3.1,7.78,2.34,0,4.23-12.09,4.23-20.91s0-14.4-4.23-14.4c-.12,0-.23,0-.34,0C59.27,36.27,59.27,39.72,59.27,44.16Z"/>
                <ellipse class={[Fill.white].join(" ")} cx="57" cy="59.7" rx="1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="59.1" cy="45.2" rx="2.1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="59.5" cy="54.4" rx="1.7" ry=".3"/>
                <path class={[Fill.white].join(" ")} d="M63 43.36c0-.23 0-.46 0-.68-.92 0-1.66.16-1.66.34S62.12 43.35 63 43.36zM57.37 47.82c0-.25-1-.45-2.23-.45h-.51c0 .29 0 .57 0 .87h.51C56.37 48.27 57.37 48.07 57.37 47.82zM58.63 64.24c0 .2.82.37 1.83.37a7.69 7.69 0 0 0 .91-.06c0-.2.1-.39.14-.6a7.33 7.33 0 0 0-1.06-.07C59.45 63.88 58.63 64 58.63 64.24zM28.39 18.72a22.41 22.41 0 0 0-2.77 1.49 45.42 45.42 0 0 1 5.5 19.18A59.49 59.49 0 0 0 28.39 18.72z"/>
                <path class={[Fill.white].join(" ")} d="M36.3,22.89A34.74,34.74,0,0,0,30.18,39.4c-.46-5.78.23-13.27,3.07-18.37Z"/>
                <path class={[Fill.white].join(" ")} d="M27.72,24.89A28.12,28.12,0,0,1,31,37.95c-.86-3.7-3.07-9-5.66-11Z"/>
                <path class={[Fill.white].join(" ")} d="M30.81,34.18c4.27,0,4.23,5.58,4.23,14.4s-1.89,20.91-4.23,20.91S26.58,57.4,26.58,48.58,26.54,34.18,30.81,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M30.81,34.18c4.27,0,4.23,5.58,4.23,14.4s-1.89,20.91-4.23,20.91S26.58,57.4,26.58,48.58,26.54,34.18,30.81,34.18Z"/>
                <path class={[Fill.white].join(" ")} d="M31.22,44.16c0,7.35-1.57,17.4-3.51,17.55.77,4.44,1.87,7.78,3.1,7.78C33.15,69.49,35,57.4,35,48.58s0-14.4-4.23-14.4c-.12,0-.23,0-.34,0C31.23,36.27,31.22,39.72,31.22,44.16Z"/>
                <ellipse class={[Fill.white].join(" ")} cx="29" cy="59.7" rx="1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="31" cy="45.2" rx="2.1" ry=".3"/>
                <ellipse class={[Fill.white].join(" ")} cx="31.4" cy="54.4" rx="1.7" ry=".3"/>
                <path class={[Fill.white].join(" ")} d="M35 43.36c0-.23 0-.46 0-.68-.92 0-1.66.16-1.66.34S34.07 43.35 35 43.36zM29.33 47.82c0-.25-1-.45-2.23-.45h-.51c0 .29 0 .57 0 .87h.51C28.33 48.27 29.33 48.07 29.33 47.82zM30.58 64.24c0 .2.82.37 1.83.37a7.69 7.69 0 0 0 .91-.06c0-.2.1-.39.14-.6a7.33 7.33 0 0 0-1.06-.07C31.4 63.88 30.58 64 30.58 64.24z"/>
            </Fragment>
        );
    }

    _renderMarketIcon = () => {
        return (
            <Fragment>
                <g>
                    <path class={[Fill.white].join(" ")} d="M66.3 23.73v2.65H60.5c-2.82 0-2.82 2.16-2.82 2.16V52.9c0 3.32-2.48 3-2.48 3H33c-1.82 0-3-2.32-3-2.32S24.21 41 22.39 36.33s3.81-5 3.81-5H54.74l0-2.48c0-5.3 5.47-5.14 5.47-5.14zM53.78 51.45A1 1 0 0 0 53 50.37H35.69a.74.74 0 0 0-.58.32 1.26 1.26 0 0 0-.24.76 1 1 0 0 0 .82 1.08H53A1 1 0 0 0 53.78 51.45zm0-4.93a1 1 0 0 0-.92-1.08H33.54a.85.85 0 0 0-.65.32 1.18 1.18 0 0 0-.27.76 1 1 0 0 0 .92 1.08H52.87A1 1 0 0 0 53.78 46.52zm0-5.26a1 1 0 0 0-1-1.08H31.35a1 1 0 0 0-.72.31 1.11 1.11 0 0 0-.3.76 1 1 0 0 0 1 1.07H52.77A1 1 0 0 0 53.78 41.26zm0-5.38A1.08 1.08 0 0 0 52.7 34.8H30A1.08 1.08 0 0 0 30 37H52.7A1.08 1.08 0 0 0 53.78 35.87zM55.65 56.67a2.92 2.92 0 1 1-2.92 2.92A2.92 2.92 0 0 1 55.65 56.67zM57 59.59A1.37 1.37 0 1 0 55.65 61 1.37 1.37 0 0 0 57 59.59zM33.26 56.67a2.92 2.92 0 1 1-2.92 2.92A2.92 2.92 0 0 1 33.26 56.67zm1.37 2.92A1.37 1.37 0 1 0 33.26 61 1.37 1.37 0 0 0 34.63 59.59z"/>
                </g>
            </Fragment>
        );
    }

    _renderIcon = () => {
        const { link } = this.props;
        switch (link) {
            case Routes.Kitchen:
                return this._renderKitchenIcon();
            case Routes.Garden:
                return this._renderGardenIcon();
            case Routes.Market:
                return this._renderMarketIcon();
            default:
                return this._renderKitchenIcon();
        }
    }

    _renderButton = () => {

        const { active } = this.props;

        const buttonLinkA = (active) ? Components.linkActive : Components.link;
        const buttonColorB = (active) ? Fill.linkButtonBlueB : Fill.linkButtonRedB;

        const { xPos, yPos } = this._getPositionByButtonType();

        return (
            <svg xmlns="http://www.w3.org/2000/svg" x={xPos} y={yPos} width={88} height={88} viewBox="0 0 88.3 88.3">
            <title>
                GardenButtonRed
            </title>
            <g id="Layer_2" data-name="Layer 2" className={[buttonLinkA].join(" ")} onClick={this.onClick}>
                <g id="Layer_1-2" data-name="Layer 1">
                    <path d="M44.17,86.33A42.17,42.17,0,1,1,86.33,44.17,42.21,42.21,0,0,1,44.17,86.33Z"/>
                    <path class={[buttonColorB].join(" ")} d="M44.17,4A40.17,40.17,0,1,1,4,44.17,40.17,40.17,0,0,1,44.17,4m0-4A44.17,44.17,0,1,0,88.33,44.17,44.22,44.22,0,0,0,44.17,0Z"/>
                    {this._renderIcon()}
                </g>
            </g>
        </svg>
    );
}


render () {

        return (
            this._renderButton()
        )
    }
}

Links.defaultProps = {
    link: Routes.Garden,
    active: true
}

export default Links;



// WEBPACK FOOTER //
// ./src/components/Interface/Link/index.js